import usePermission from 'routes/usePermission';
import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { PAGE_NAMES } from 'constant';

import dashboard from 'assets/home/dashboard.png';
import settings from 'assets/home/settings.png';
import admin from 'assets/home/admin.png';
import settingsV2 from 'commons-ui/src/assets/settingsV2/settingV2Icon.png';

const useMenuItems = () => {
	const { hasPermission } = usePermission();
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const menuItems = [
		{
			label: 'Dashboard',
			img: dashboard,
			url: `/${PAGE_NAMES.dashboard}`,
			isEnabled: () => {
				return hasPermission({ configPageName: PAGE_NAMES.dashboard });
			}
		},
		{
			label: 'Game Admin',
			img: admin,
			url: `/${PAGE_NAMES.gameAdmin}`,
			isEnabled: () => {
				return hasPermission({ configPageName: PAGE_NAMES.gameAdmin });
			}
		},
		{
			label: 'Settings',
			img: settings,
			url: `/${PAGE_NAMES.settings}`,
			isEnabled: () => {
				return hasPermission({ configPageName: PAGE_NAMES.settings });
			}
		},
		{
			label: 'User And Permissions Settings',
			img: settingsV2,
			url: `/${PAGE_NAMES.settingsV2}`,
			isEnabled: () => {
				return hasPermissionV2({ configPageName: PAGE_NAMES.settingsV2 });
			}
		}
	];

	return {
		menuItems
	};
};

export default useMenuItems;
